interface FlowOptions {
  clientId: string;
  subscription: { [key: string]: any };
}

declare global {
  interface Window {
    ProsperStack: {
      flow: (options: FlowOptions) => Promise<any>;
    };
  }
}

export const prosperStack = window.ProsperStack;
